import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

import { discussionVoteCreate } from "~/store/graphql/mutations/discussionVoteCreate.graphql";

const createDiscussionVote = async function (
  { commit, state },
  { discussionId }
) {
  commit("START_LOADING");

  await runGraphQLQuery(
    discussionVoteCreate,
    {
      entityId: discussionId,
      entityType: "DISCUSSION",
    },
    this.$axios
  );

  commit("CREATE_DISCUSSION_VOTE", { discussionId });

  commit("END_LOADING");

  return Promise.resolve();
};

export default createDiscussionVote;
